import React from 'react';
import Referral from '../components/MyProfile/Referral/Referral';
import { Helmet } from 'react-helmet-async';

const ReferralPage = () => {
  return (
    <>
      <Helmet>
        <title>Referral Program | Circledin</title>
        <meta name="description" content="Invite friends to Circledin and earn rewards. Give $10, get $10 with every successful referral." />
      </Helmet>
      <Referral />
    </>
  );
};

export default ReferralPage;